import { createReducer } from "reduxsauce";
import { StudentEventsTypes as Types, UserTypes } from "../actions";
import storeInitialState from "../store/initial-state";

export const INITIAL_STATE = storeInitialState.studentEvents;

export const clearStudentEvents = state => ({
  ...state,
  data: [],
});

export const getStudentEventsFailure = state => ({
  ...state,
  loading: false,
});
export const getStudentEventsRequest = state => ({
  ...state,
  loading: true,
});
// The design pages explicitly (numbered pager), so a page replaces the rows
// rather than appending to them.
export const getStudentEventsSuccess = (state, action) => {
  const {
    eventsData: { events, total, per_page: perPage },
    params,
  } = action;

  return {
    ...state,
    data: events,
    total,
    perPage: perPage || state.perPage,
    params: { ...state.params, ...params },
    loading: false,
  };
};

// `selected` stays null on failure, so without this flag the panel cannot tell
// "still loading" from "loaded nothing" and renders an endless spinner.
export const getStudentEventFailure = state => ({
  ...state,
  loadingSelected: false,
  selectedFailed: true,
});
export const getStudentEventRequest = state => ({
  ...state,
  loadingSelected: true,
  selected: null,
  selectedFailed: false,
});
export const getStudentEventSuccess = (state, action) => ({
  ...state,
  loadingSelected: false,
  selected: action.eventData,
  selectedFailed: false,
});

// Signing up and withdrawing both return the updated event, so the row in the
// table and the open detail panel are patched from the same payload — the
// status pill flips without a refetch.
const applyRegistrationChange = (state, action) => {
  const { eventData } = action;

  return {
    ...state,
    saving: false,
    selected: eventData,
    data: state.data.map(event =>
      event.id === eventData.id ? { ...event, ...eventData } : event,
    ),
  };
};

export const signUpForEventFailure = state => ({
  ...state,
  saving: false,
});
export const signUpForEventRequest = state => ({
  ...state,
  saving: true,
});
export const signUpForEventSuccess = applyRegistrationChange;

export const withdrawFromEventFailure = state => ({
  ...state,
  saving: false,
});
export const withdrawFromEventRequest = state => ({
  ...state,
  saving: true,
});
export const withdrawFromEventSuccess = applyRegistrationChange;

const logout = () => INITIAL_STATE;

export const HANDLERS = {
  [Types.CLEAR_STUDENT_EVENTS]: clearStudentEvents,
  [Types.GET_STUDENT_EVENTS_FAILURE]: getStudentEventsFailure,
  [Types.GET_STUDENT_EVENTS_REQUEST]: getStudentEventsRequest,
  [Types.GET_STUDENT_EVENTS_SUCCESS]: getStudentEventsSuccess,
  [Types.GET_STUDENT_EVENT_FAILURE]: getStudentEventFailure,
  [Types.GET_STUDENT_EVENT_REQUEST]: getStudentEventRequest,
  [Types.GET_STUDENT_EVENT_SUCCESS]: getStudentEventSuccess,
  [Types.SIGN_UP_FOR_EVENT_FAILURE]: signUpForEventFailure,
  [Types.SIGN_UP_FOR_EVENT_REQUEST]: signUpForEventRequest,
  [Types.SIGN_UP_FOR_EVENT_SUCCESS]: signUpForEventSuccess,
  [Types.WITHDRAW_FROM_EVENT_FAILURE]: withdrawFromEventFailure,
  [Types.WITHDRAW_FROM_EVENT_REQUEST]: withdrawFromEventRequest,
  [Types.WITHDRAW_FROM_EVENT_SUCCESS]: withdrawFromEventSuccess,
  [UserTypes.LOGOUT]: logout,
};

export default createReducer(INITIAL_STATE, HANDLERS);
